import { AccountingSystem } from '../accounting';
import { Entity, AuditDetails } from '../entity';

export enum PaymentType {

    // ACCRECPAYMENT	Accounts Receivable Payment
    // ACCPAYPAYMENT	Accounts Payable Payment
    Receivable = 'Accounts Receivable',
    Payable = 'Accounts Payable',


    // ARCREDITPAYMENT	Accounts Receivable Credit Payment (Refund)
    // APCREDITPAYMENT	Accounts Payable Credit Payment(Refund)
    ReceivableCredit = 'Accounts Receivable Credit',
    PayableCredit = 'Accounts Payable Credit',


    // ARPREPAYMENTPAYMENT	Accounts Receivable Prepayment Payment(Refund)
    // APPREPAYMENTPAYMENT	Accounts Payable Prepayment Payment(Refund)
    ReceivablePrepayment = 'Accounts Receivable Prepayment',
    PayablePrepayment = 'Accounts Payable Prepayment',


    // AROVERPAYMENTPAYMENT	Accounts Receivable Overpayment Payment(Refund)
    // APOVERPAYMENTPAYMENT	Accounts Payable Overpayment Payment(Refund)
    ReceivableOverpayment = 'Accounts Receivable Overpayment',
    PayableOverpayment = 'Accounts Payable Overpayment',
}

export enum PaymentStatus {
    Pending = 'Pending',
    Success = 'Success',
    Error = 'Error',
    IntegrationError = 'Integration Error',
    WorkBuddyError = 'WorkBuddy Error'
}

export enum PaymentMethodType {
    Manual = 'Manual',
    Online = 'Online'
}

export enum ReconciliationStatus {
    Reconciled = 'Reconciled',
    NotReconciled = 'Not Reconciled',
}

export enum PaymentSource {
    Xero = 'Xero',
    WorkBuddy = 'WorkBuddy',
    Stripe = 'Stripe',
    QuickBooks = 'QuickBooks',
    MYOB = 'MYOB',
    WBBulkImport = 'WB Bulk Import',
    Jobpac = 'Jobpac'
}

export interface PaymentMethodEntity extends Entity {
    type: PaymentMethodType;
    requiresReconcile: boolean;
}

export interface PaymentMethod extends PaymentMethodEntity {
    availableOnFieldApp: boolean;
    isServiceConnection: boolean;
    companies: Entity[];
    inUse?: boolean;
}

export interface Payment extends Entity, AuditDetails {
    entity: Entity;
    amount: number;
    date: Date;
    note?: string;
    reference: string;
    method: PaymentMethodEntity;
    account?: Entity;
    type: PaymentType;
    status: PaymentStatus;
    merchant?: any;
    receiver?: Entity;
    company?: Entity;
    payer?: string;
    timezone?: string;
    reconciled?: ReconciliationStatus;
    integrationId?: string;
    source?: PaymentSource;
    accountingSystem?: AccountingSystem;
}


export interface PaymentIntentResult {
    success: boolean;
    intent: any;
    message: string;
}


export interface PaymentEditorInfo {
    amount: number;
    amountEditable: boolean,
    type: PaymentType,
    title?: 'Receive' | 'Refund' | 'Pay',
}

export interface TerminalTokenResult {
    success: boolean;
    token: string;
    message: string;
}

export interface TerminalLocationResult {
    success: boolean;
    locationId: string;
    message: string;
}